module.exports = __webpack_public_path__ + "fonts/Poppins-Light.9bec05a.woff2";